import { render, staticRenderFns } from "./screening-edit-task-dialog.vue?vue&type=template&id=554da7f0&scoped=true"
import script from "./screening-edit-task-dialog.vue?vue&type=script&lang=js"
export * from "./screening-edit-task-dialog.vue?vue&type=script&lang=js"
import style0 from "./screening-edit-task-dialog.vue?vue&type=style&index=0&id=554da7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554da7f0",
  null
  
)

export default component.exports